/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */

import React from "react";
import {Stack} from "@mui/material";
import {EmployeesFilter} from "../../interfaces/Global";
import EmployeesFilterForm from "../../components/EmployeesFilterForm";

export interface ConfigEmployeesFilterProps {
	filter: EmployeesFilter
	setFilter: (filter: EmployeesFilter) => void
	disabled?: boolean
}

export default function ConfigEmployeesFilter(props: ConfigEmployeesFilterProps) {

	return (
		<Stack>
			<EmployeesFilterForm
				filter={props.filter}
				setFilter={props.setFilter}
				allowZeroConditions={true}
				disabled={props.disabled}
			/>
		</Stack>
	);

}